import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Shield } from "lucide-react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useConsoleAuth } from "@/contexts/ConsoleAuthContext";
import "@/styles/console.css";

export default function ConsoleLogin() {
  const { login, isAuthenticated, loading } = useConsoleAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("superadmin@restauranterp.local");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && isAuthenticated) {
    return <Navigate to="/console" replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password, true);
      toast.success("Welcome to Restaurant ERP Console");
      navigate("/console", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.errors?.email?.[0] || err.response?.data?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="console-root relative flex min-h-screen items-center justify-center px-4">
      <div className="console-ambient" aria-hidden />
      <motion.form
        onSubmit={onSubmit}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="console-card relative z-10 w-full max-w-md p-8 shadow-2xl shadow-teal-500/5"
      >
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-2xl bg-teal-400/15 ring-1 ring-teal-400/30">
            <Shield className="h-6 w-6 text-teal-300" />
          </div>
          <h1 className="console-display text-2xl font-bold tracking-tight text-white">
            Restaurant ERP Console
          </h1>
          <p className="mt-2 text-[13px] text-slate-400">
            Platform access for company licensing &amp; features
          </p>
        </div>

        <label className="mb-4 block">
          <span className="mb-1.5 block text-[12px] text-slate-400">Email</span>
          <input
            className="console-input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="mb-6 block">
          <span className="mb-1.5 block text-[12px] text-slate-400">Password</span>
          <input
            className="console-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <button type="submit" className="console-btn console-btn-primary w-full" disabled={busy}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Sign in
        </button>
      </motion.form>
    </div>
  );
}
